import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { MemberService, PlayerAdjustmentService, FeeColumnFilterPanelService } from '../../../../services';
import { ScholarshipInfoService } from '../../../../shared-services/scholarship-info.service';
import { StorageUtil } from '../../../../store';

@Component({
  selector: 'app-scholarship-information',
  templateUrl: './scholarship-information.component.html',
  styleUrls: ['./scholarship-information.component.css']
})
export class ScholarshipInformationComponent implements OnInit {
  public scholarshipInfoForm: FormGroup;
  public validationMessages = {};
  public scholarshipTypes: any[];

  @Input() ClubUserProgramFeeID: string;
  @Input() ClubProgramFeeID: string;

  constructor(private fb: FormBuilder,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private memberService: MemberService,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private playerAdjustmentService: PlayerAdjustmentService,
    private scholarshipInfoService: ScholarshipInfoService,
  ) {
    this.validationMessages = {
      'Required': 'This field is required.'
    };
    this.scholarshipTypes = [
      { 'key': 1, 'value': 'Financial Issues' },
      { 'key': 2, 'value': 'Exceptional Player' },
      { 'key': 3, 'value': 'Loss of Job' },
      { 'key': 4, 'value': 'Family Loss' },
      { 'key': 5, 'value': 'Military' },
      { 'key': 6, 'value': 'Other' },
    ];
  }

  ngOnInit() {
    this.initForm();
    this.getScholarship();
  }

  // Autopopulate saved scholarship data.
  getScholarship() {
    this.scholarshipInfoService.getData().subscribe((rs: any) => {
      console.log('this.scholarshipInfoService.getData():', rs);
      this.scholarshipInfoForm.patchValue({
        'ScholarshipePlayer': (rs.isScholarship) ? '1' : '0',
        'AmountScholarshiped': rs.amount.toString(),
        'ScholarshipType': rs.scholarshipTypeID.toString()
      });
    });
  }

  initForm() {
    this.scholarshipInfoForm = this.fb.group({
      ScholarshipePlayer: ['', [Validators.required]],
      AmountScholarshiped: ['', [Validators.required]],
      ScholarshipType: ['', [Validators.required]],
    });
  }

  isScholarshipePlayerYesSelected() {
    return (!!this.scholarshipInfoForm.get('ScholarshipePlayer'))
      && (this.scholarshipInfoForm.get('ScholarshipePlayer').value === '1');
  }

  isAmountScholarshipedVisible() {
    const isAmountScholarshipedVisible = this.isScholarshipePlayerYesSelected();
    if (isAmountScholarshipedVisible === false) {
      this.removeValidaion('AmountScholarshiped');
    }
    return isAmountScholarshipedVisible;
  }

  isScholarshipePlayerValid() {
    return this.scholarshipInfoForm.get('ScholarshipePlayer').errors
      && (this.scholarshipInfoForm.get('ScholarshipePlayer').touched
        || this.scholarshipInfoForm.get('ScholarshipePlayer').dirty);
  }
  isAmountScholarshipedValid() {
    return this.scholarshipInfoForm.get('AmountScholarshiped').errors
      && (this.scholarshipInfoForm.get('AmountScholarshiped').touched
        || this.scholarshipInfoForm.get('AmountScholarshiped').dirty);
  }
  isScholarshipTypeValid() {
    return this.scholarshipInfoForm.get('ScholarshipType').errors
      && (this.scholarshipInfoForm.get('ScholarshipType').touched
        || this.scholarshipInfoForm.get('ScholarshipType').dirty);
  }
  validateUi() {
    Object.keys(this.scholarshipInfoForm.controls).forEach(field => {
      const control = this.scholarshipInfoForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  removeValidaion(name) {
    const control = this.scholarshipInfoForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }

  onSubmit(event, formStatus) {
    event.stopPropagation();
    if (formStatus === 'VALID') {
      const obj = {
        ClubUserProgramFeeID: Number(this.ClubUserProgramFeeID),
        // ClubProgramFeeAdjustmentTypeID: Number(this.scholarshipInfoForm.value.ScholarshipePlayer),
        ClubProgramFeeAdjustmentTypeID: 2,
        ClubUserProgramScholarshipTypeID: Number(this.scholarshipInfoForm.value.ScholarshipType),
        Amount: Number(this.scholarshipInfoForm.value.AmountScholarshiped),
        AddedBy: StorageUtil.userID
      };
      console.log(obj);
      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      this.playerAdjustmentService.saveScholarshipInformation(obj).subscribe((data: any) => {
        event.target.innerHTML = 'Save';
        event.target.disabled = false;
        this.clearFormData();
        this.closeSideOverlay();
        this.alertMessage('success', data.result);
      }, error => {
        this.alertMessage('error', error.statusText);
      });
    } else {
      this.validateUi();
    }
  }

  clearFormData() {
    this.scholarshipInfoForm.reset();
  }

  onReset(event) {
    event.stopPropagation();
    this.clearFormData();
    this.closeSideOverlay();
  }

  closeSideOverlay() {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
  }

  alertMessage(status, message) {
    const toast = this.notificationsService.success(status, message, {
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/scholarship-information/scholarship-information.component.ts